<div class="staff-details-container">
  

  <!-- Skeleton Loading -->
  <div *ngIf="isLoading" class="skeleton-wrapper">
      <!-- Avatar Skeleton -->
      <div class="text-center">
          <p-skeleton shape="circle" size="6rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="8rem" height="2rem" styleClass="mx-auto"></p-skeleton>
      </div>

      <!-- Details Skeleton -->
      <div class="surface-0 border-round shadow-3 px-4 py-2 mb-3">
          <div class="grid my-1">
              <div class="col-12 md:col-6 my-1" *ngFor="let i of [1,2,3,4,5,6]">
                  <p-skeleton width="4rem" height="1rem" styleClass="mb-2"></p-skeleton>
                  <p-skeleton height="2rem"></p-skeleton>
              </div>
          </div>
      </div>

      <!-- Password Section Skeleton -->
      <div class="surface-0 border-round shadow-3 p-4 mb-3">
          <div class="flex justify-content-between flex-wrap">
              <div>
                  <p-skeleton width="4rem" height="1rem" styleClass="mb-2"></p-skeleton>
                  <p-skeleton width="8rem" height="2rem"></p-skeleton>
                  <p-skeleton width="12rem" height="1rem" styleClass="mt-2"></p-skeleton>
              </div>
              <p-skeleton width="8rem" height="2rem"></p-skeleton>
          </div>
      </div>

      <!-- Theme Section Skeleton -->
      <div class="surface-0 border-round shadow-3 p-4 mb-3">
          <p-skeleton width="8rem" height="1.5rem" styleClass="mb-3"></p-skeleton>
          <p-skeleton height="3rem" styleClass="mb-3"></p-skeleton>

          <div class="grid">
              <div class="col-12 md:col-4" *ngFor="let i of [1,2,3]">
                  <p-skeleton width="8rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                  <p-skeleton height="10rem" styleClass="mb-2"></p-skeleton>
                  <div class="flex justify-content-center">
                      <p-skeleton shape="circle" size="1rem" *ngFor="let j of [1,2,3,4,5,6]" styleClass="mr-2"></p-skeleton>
                  </div>
              </div>
          </div>
      </div>

      <!-- Public Bio Skeleton -->
      <div class="surface-0 border-round shadow-3 p-4">
          <p-skeleton width="8rem" height="1.5rem" styleClass="mb-3"></p-skeleton>

          <div class="mb-3">
              <p-skeleton width="4rem" height="1rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton height="2.5rem"></p-skeleton>
          </div>

          <div class="mb-3">
              <p-skeleton width="4rem" height="1rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton height="6rem"></p-skeleton>
          </div>

          <div>
              <p-skeleton width="4rem" height="1rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton height="6rem"></p-skeleton>
          </div>
      </div>

      <!-- Buttons Skeleton -->
      <div class="flex align-items-center justify-content-between my-3">
          <p-skeleton width="6rem" height="2.5rem"></p-skeleton>
          <p-skeleton width="6rem" height="2.5rem"></p-skeleton>
      </div>
  </div>

  <!-- Actual Content -->
  <div *ngIf="!isLoading && staffDetails">
      <!-- Avatar -->
      <div class="text-center">
          <p-avatar *ngIf="getImage() as data; else noImage" [image]="data.path" styleClass="w-6rem h-6rem block border-round mx-auto"></p-avatar>
          <ng-template #noImage>
            <p-avatar [label]="this.staffDetails?.name | titlecase | shortName" shape="circle"></p-avatar>
          </ng-template>
          <p-button icon="fa fa-pencil" label="Edit picture" styleClass="text-sm p-button-text shadow-none ml-2">
              <ngx-file-drop class="opacity-0 absolute w-full h-full top-0 left-0 z-4 cursor-pointer" dropZoneLabel="Drop files here" (onFileDrop)="handleFileSelect($event)">
                  <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                      <div (click)="openFileSelector()" class="w-full h-full absolute left-0 top-0"></div>
                  </ng-template>
              </ngx-file-drop>
          </p-button>
      </div>

      <!-- Details -->
      <div class="surface-0 border-round shadow-3 px-4 py-2 mb-3">
          <div class="grid my-1">
              <div class="col-12 md:col-6 my-1">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.STAFFNAME' | translate}}</label>
                  <strong class="block">{{staffDetails.name}}</strong>
              </div>
              <div class="col-12 md:col-6 my-1">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.MOBILENUMBER' | translate}}</label>
                  <strong class="block">{{staffDetails.mobile_country_code}} {{staffDetails.mobile_number}}</strong>
              </div>
              <div class="col-12 md:col-6 my-1">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.EMAILADDRESS' | translate}}</label>
                  <strong class="block">{{staffDetails.email_id}}</strong>
              </div>
              <div class="col-12 md:col-6 my-1">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.ACCESS_TEMPLATE' | translate}}</label>
                  <strong class="block">{{staffDetails.claim_template_name}}</strong>
              </div>
              <div class="col-12 md:col-6 my-1">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.LABEL_DESIGNATION' | translate}}</label>
                  <strong class="block">{{staffDetails.designation || 'N/A'}}</strong>
              </div>
              <div class="col-12 md:col-6 my-1">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.LABEL_ROLE' | translate}}</label>
                  <strong class="block">{{staffDetails.role}}</strong>
              </div>
          </div>
      </div>

      <!-- Password -->
      <div class="surface-0 border-round shadow-3 p-4 mb-3">
          <div class="flex justify-content-between flex-wrap">
              <div>
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.SETPASSWORD' | translate}}</label>
                  <strong class="block">**************</strong>
                  <small class="block text-600 text-xs">
                      ( {{'CreateEditStaff.LAST_CHANGED_ON' | translate }} {{staffDetails.password_last_changed | datetimeformat}})
                  </small>
              </div>
              <p-button type="submit" label="Change password" icon="fa fa-pencil" (onClick)="showChangePassword = true" styleClass="text-sm p-button-text font-bold"> </p-button>
          </div>
      </div>

      <!-- Theme -->
      <div class="surface-0 border-round shadow-3 p-4 mb-3">
          <h6 class="text-sm mb-3">{{'CreateEditStaff.THEME' | translate}}</h6>
          <p class="text-sm mb-3">{{'CreateEditStaff.THEME_INFO' | translate}}</p>

          <div class="grid text-sm">
              <div *ngFor="let theme of themes; let i = index" class="col-12 md:col-4">
                  <div class="flex align-items-center" [ngClass]="{'text-primary font-bold': selectedTheme && selectedTheme.themeMode === theme.themeMode}">
                      <i [class]="theme.icon + ' mr-2'"></i>
                      <span>{{theme.name}}</span>
                  </div>

                  <!-- Theme Preview Light -->
                  <div
                      *ngIf="theme.themeMode === 'light'"
                      (click)="selectDefaultTheme('light'); $event.stopPropagation()"
                      class="border-round-2xl border-1 border-300 h-10rem mt-2 cursor-pointer relative"
                      [ngClass]="{'border-primary shadow-3': selectedTheme.themeMode === 'light', 'border-300': selectedTheme.themeMode !== 'light'}"
                  >
                      <!-- Loading Overlay -->
                      <div *ngIf="isThemeChanging && selectedTheme.themeMode === 'light'" 
                           class="absolute flex align-items-center justify-content-center w-full h-full z-5 border-round-2xl"
                           style="background-color: rgba(255, 255, 255, 0.7);">
                          <i class="fa fa-spinner fa-spin text-primary text-2xl"></i>
                      </div>
                      <!-- End Loading Overlay -->
                      
                      <div class="h-2rem surface-200 border-round-top-2xl"></div>
                      <div class="flex p-2 flex-wrap justify-content-between">
                          <div class="w-7 pr-4">
                              <div class="h-1rem surface-200 mb-1"></div>
                              <div class="h-1rem surface-200"></div>
                          </div>
                          <div class="w-5">
                              <div class="h-1rem border-round border-1 border-primary"></div>
                          </div>
                          <div class="w-12 mt-1">
                              <div class="h-2rem surface-200"></div>
                              <div class="h-2rem bg-primary border-round mt-2"></div>
                          </div>
                      </div>
                  </div>
                  <!-- Theme Preview Light-->

                  <!-- Theme Preview -->
                  <div
                      *ngIf="theme.themeMode === 'dark'"
                      (click)="selectDefaultTheme('dark'); $event.stopPropagation()"
                      class="border-round-2xl surface-900 border-1 border-300 h-10rem mt-2 cursor-pointer relative"
                      [ngClass]="{'border-primary shadow-3': selectedTheme.themeMode === 'dark', 'border-300': selectedTheme.themeMode !== 'dark'}"
                  >
                      <!-- Loading Overlay -->
                      <div *ngIf="isThemeChanging && selectedTheme.themeMode === 'dark'" 
                           class="absolute flex align-items-center justify-content-center w-full h-full z-5 border-round-2xl"
                           style="background-color: rgba(0, 0, 0, 0.5);">
                          <i class="fa fa-spinner fa-spin text-primary text-2xl"></i>
                      </div>
                      <!-- End Loading Overlay -->
                      
                      <div class="h-2rem surface-0 opacity-20 border-round-top-2xl"></div>
                      <div class="flex p-2 flex-wrap justify-content-between">
                          <div class="w-7 pr-4">
                              <div class="h-1rem surface-0 opacity-20 mb-1"></div>
                              <div class="h-1rem surface-0 opacity-20"></div>
                          </div>
                          <div class="w-5">
                              <div class="h-1rem border-round border-1 border-primary"></div>
                          </div>
                          <div class="w-12 mt-1">
                              <div class="h-2rem surface-0 opacity-20"></div>
                              <div class="h-2rem bg-primary border-round mt-2"></div>
                          </div>
                      </div>
                  </div>
                  <!-- Theme Preview -->

                  <!-- Theme Preview -->
                  <div
                      *ngIf="theme.themeMode === 'system'"
                      (click)="selectDefaultTheme('system'); $event.stopPropagation()"
                      class="border-round-2xl border-1 border-300 h-10rem mt-2 cursor-pointer relative"
                      [ngClass]="{'border-primary shadow-3': selectedTheme.themeMode === 'system', 'border-300': selectedTheme.themeMode !== 'system'}"
                  >
                      <!-- Loading Overlay -->
                      <div *ngIf="isThemeChanging && selectedTheme.themeMode === 'system'" 
                           class="absolute flex align-items-center justify-content-center w-full h-full z-5 border-round-2xl"
                           style="background-color: rgba(255, 255, 255, 0.7);">
                          <i class="fa fa-spinner fa-spin text-primary text-2xl"></i>
                      </div>
                      <!-- End Loading Overlay -->
                      
                      <div class="h-2rem surface-200 border-round-top-2xl"></div>
                      <div class="flex p-2 flex-wrap justify-content-between">
                          <div class="w-7 pr-4">
                              <div class="h-1rem surface-200 mb-1"></div>
                              <div class="h-1rem surface-200"></div>
                          </div>
                          <div class="w-5">
                              <div class="h-1rem border-round border-1 border-primary"></div>
                          </div>
                          <div class="w-12 mt-1">
                              <div class="h-2rem surface-200"></div>
                              <div class="h-2rem bg-primary border-round mt-2"></div>
                          </div>
                      </div>
                  </div>
                  <!-- Theme Preview -->

                  <!-- Color Palette -->
                  <div class="flex flex-column mt-2 mb-2">
                    <div class="flex flex-wrap">
                      <ng-container *ngFor="let color of theme.themes[0].colors; let i = index">
                        <div
                          class="border-circle"
                          [ngStyle]="{
                            width: '18px',
                            height: '18px',
                            background: 'var(--p-' + color + '-500)',
                            margin: '4px',
                            position: 'relative'
                          }"
                          [ngClass]="isThemeChanging ? 'opacity-60' : 'cursor-pointer'"
                          [attr.aria-label]="'color-selector-' + color"
                          [ngClass]="{'border-2 border-primary shadow-3': selectedTheme.themeMode === theme.themeMode && selectedColor === color, 'border-300': selectedTheme.themeMode === theme.themeMode && selectedColor !== color}"
                          (click)="!isThemeChanging && selectThemeColor(theme.themeMode, color); $event.stopPropagation()">
                          <div *ngIf="selectedTheme.themeMode === theme.themeMode && selectedColor === color" 
                               class="absolute flex align-items-center justify-content-center w-full h-full">
                            <i class="pi pi-check text-white text-xs"></i>
                          </div>
                          <div *ngIf="isThemeChanging && selectedTheme === color"
                               class="absolute w-2rem h-2rem flex align-items-center justify-content-center"
                               style="top: -0.5rem; left: -0.5rem;">
                            <i class="fa fa-spinner fa-spin text-primary text-xs"></i>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <!-- End Color Palette -->
              </div>
          </div>
      </div>

      <!-- Public Bio -->
      <div class="surface-0 border-round shadow-3 p-4">
          <form [formGroup]="bioForm">
              <h6 class="text-sm mb-3">{{'CreateEditStaff.PUBLICBIO' | translate}}</h6>

              <div class="mb-3">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.LABEL_VIDEOURL' | translate}}</label>
                  <input type="url" formControlName="public_bio_video_url" class="w-full text-sm" pInputText placeholder="Video URL" />
              </div>

              <div class="mb-3">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.LABEL_BIO' | translate}}</label>
                  <textarea formControlName="public_bio_description" pInputTextarea class="w-full text-sm h-6rem" placeholder="Bio"></textarea>
              </div>

              <div>
                  <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CreateEditStaff.LABEL_ACHIEVEMENTS' | translate}}</label>
                  <textarea formControlName="public_bio_achievements" pInputTextarea class="w-full text-sm h-6rem" placeholder="Achievements"></textarea>
              </div>
          </form>
      </div>

      <!-- Buttons -->
      <div class="flex align-items-center justify-content-between my-3">
          <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="text-sm p-button-link"></p-button>
          <p-button [label]="'common.BUTTONS.BUTTON-TEXT-SAVE' | translate" (onClick)="onSaveChanges()" styleClass="text-sm"></p-button>
      </div>
  </div>
</div>

<staff-change-password [staff]="staffDetails" [visible]="showChangePassword" (closePopup)="setCloseChangePassword()" (passwordChanged)="onPasswordChanged($event)"></staff-change-password>
